import { useEffect, useState } from "react";

import { useSelectedDealer } from "components";
import { AcceptAgreementModal, AccessKeysDashboardTable, AccessKeysDashboardToolbar } from "modules/AccessKeysDashboard/components";

export const AccessKeysDashboard = () => {
  const { selectedDealer } = useSelectedDealer();
  const [showAgreementsModal, setShowAgreementsModal] = useState(!selectedDealer?.accepted_api_agreement);

  useEffect(() => {
    setShowAgreementsModal(!selectedDealer?.accepted_api_agreement);
  }, [selectedDealer]);

  const handleCloseAgreementsModal = () => setShowAgreementsModal(false);

  if (showAgreementsModal) return <AcceptAgreementModal onClose={handleCloseAgreementsModal} open={showAgreementsModal} />;

  return (
    <>
      <AccessKeysDashboardToolbar />
      <AccessKeysDashboardTable />
    </>
  );
};
